import React, { Component, Fragment } from 'react';
import { connect } from "react-redux";
import { Link } from 'react-router-dom'
import logoutUser from '../../services/connect/logoutConnector';
import APP from 'app';
import { getUserInfoData, getUserDues } from "../../actions/userInfoAction";
import { loginGuestUser } from "../../actions/userActions";
import configHelper from 'helper/Config/configHelper';
import { refreshToken, replaceToken } from "../../actions/refreshTokenActions";
import { EmailValidation, checkEmpty } from './../../library/validation';
import TopBarStrip from '@tgslabs/topbar/build/';
import B2cLogin from './../../components/common/b2c/';
import { navigateTo } from 'actions/routerActions';

const { Utils } = APP,
    { formatPrice, getHotelTopBarLinks, errorToaster, translateData, setCookie, translateText } = Utils;

const { baseUrl = '', afterLogoutPath = '/nav', redirectionConfig, redirectionDomains, showDepositCredit = true, clientType = 'b2b' } = APP.Utils.getConfig();

const {
    redirectionConfig: _redirectionConfig = redirectionConfig,
    redirectionDomains: _redirectionDomains = redirectionDomains,
    onloadPopupConfig = {}
} = APP.Utils.fetchGlobal();

const { displayOnLogin = false } = onloadPopupConfig;

class TopMenuList extends Component {
    constructor() {
        super();
        this.state = {
            showBalance: false,
            showBooking: false,
            mybooking: {
                email: '',
                bookingId: ''
            },
            showLogin: false,
            openModal: false,
            bookingIdErr: '',
        }
        this.balancehandler = this.balancehandler.bind(this);
        this.refreshToken = this.refreshToken.bind(this);
        this.replaceToken = this.replaceToken.bind(this);
    }

    componentDidMount() {
        this.props.getUserInfoData();
    }

    logout = async () => {
        await logoutUser();
        APP.Utils.removeCookie('uuid');
        APP.Utils.removeCookie('SBT');
        if (displayOnLogin) {
            APP.Utils.removeCookie('isHotelPopupLoaded');
        }
        sessionStorage.clear();
        APP.Utils.deleteLocalStorage('userConfig');
        if (clientType == 'b2c') {
            this.props.loginGuestUser();
        } else {
            window.location.href = afterLogoutPath;
        }
    }

    balancehandler = () => {
        this.setState({
            showBalance: !this.state.showBalance
        })
    }

    loginHandler = () => {
        this.setState({
            showLogin: true,
            openModal: true
        })
    }

    onCloseModal = () => {
        this.setState({ openModal: false });
    };

    myBookingHandler = () => {
        this.setState({
            showBooking: !this.state.showBooking
        })
    }

    handleInputChange = (value, name) => {
        this.setState({
            mybooking: {
                ...this.state.mybooking,
                [name]: value
            }
        });
    };

    fetchBooking = () => {
        const { mybooking = {} } = this.state;
        const { email = '', bookingId = '' } = mybooking;
        const validBooking = checkEmpty('Booking Id', bookingId, true);
        const isValid = EmailValidation(email);
        if (isValid === true && validBooking === true) { // boolean matching as we also have object in same response
            this.setState({
                showBooking: !this.state.showBooking
            });
            window.location.href = `/hotel/confirmation/?bookingId=${bookingId}&email=${email}`
        } else {
            this.setState({
                emailErr: isValid,
                bookingIdErr: validBooking
            });
        }
    };

    refreshToken() {
        this.props.refreshToken();
    }

    replaceToken() {
        this.props.replaceToken(this.props.sbt);
    }

    getUserDues = () => {
        this.props.getUserDues()
    }

    componentWillReceiveProps(newProps) {
        const { replacedUser = {}, loginSuccess = false } = newProps;
        if (!APP.Utils.isEmpty(replacedUser)) {
            const { role = "AGENT" } = replacedUser;
            APP.Utils.redirect(_redirectionConfig[role]);
        }

        if (loginSuccess && this.state.openModal) {
            this.refreshToken();
            this.setState({
                openModal: false
            });
        }
    }

    render() {
        const { enablePointsAndCoins = false } = APP.Utils.getConfig();
        const { showBooking = false, openModal = false } = this.state;
        const { userInfo = {}, sbt = '', loading = false, topMenu = [] } = this.props;
        const showSbt = (sbt && sbt !== 'undefined');
        const menuOptionsData = translateData(topMenu, 'Topbar');
        const topBarStaticData = {
            userIdsText: translateText("userId", "Topbar-staticData") || "UserId",
            productsText: translateText("products", "Topbar-staticData") || "Products",
            noLinkedUsers: translateText("noLinkedUsers", "Topbar-staticData") || "No Linked Users",
            switchUserText: translateText("switchUser", "Topbar-staticData") || "Switch User",
            cancelButton: translateText("cancelButton", "Topbar-staticData") || "Cancel",
            switchButton: translateText("switchButton", "Topbar-staticData") || "Switch",
            typeText: translateText("type", "Topbar-staticData") || "Type",
            depositText: translateText("deposit", "Topbar-staticData") || "Deposit",
            creditText: translateText("credit", "Topbar-staticData") || "Credit",
            balanceText: translateText("balance", "Topbar-staticData") || "Balance",
            dailyLimitText: translateText("dailyLimit", "Topbar-staticData") || "Daily Limit",
            moreInfoText: translateText("moreInfo", "Topbar-staticData") || "More Info",
            lockDateText: translateText("lockDate", "Topbar-staticData") || "Lock Date",
            currentStatementText: translateText("currentStatement", "Topbar-staticData") || "Current Cycle Statement",
            amountText: translateText("amount", "Topbar-staticData") || "Amount",
            overDueText: translateText("overDue", "Topbar-staticData") || "Over Due",
            dueDateText: translateText("dueDate", "Topbar-staticData") || "Due Date",
            outStandingStatementText: translateText("outStandingStatement", "Topbar-staticData") || "Outstanding Statement"
        }

        return (
            <Fragment>
                <TopBarStrip
                    userInfo={userInfo}
                    logoutFn={this.logout}
                    refreshToken={this.refreshToken}
                    replaceToken={this.replaceToken}
                    showSbt={showSbt}
                    baseUrl={baseUrl}
                    isB2C={APP.Utils.isB2cClient()}
                    redirectionDomains={{
                        DASHBOARD: _redirectionDomains.DASHBOARD,
                        FLIGHT: _redirectionDomains.FLIGHT,
                    }}
                    loginHandler={this.loginHandler}
                    myBookingControls={{
                        showBooking,
                        myBookingHandler: this.myBookingHandler,
                        handleInputChange: this.handleInputChange,
                        fetchBooking: this.fetchBooking,
                        emailErr: this.state.emailErr,
                        bookingIdErr: this.state.bookingIdErr,
                        closeOnEsc: true,
                        closeOnOverlayClick: true,
                    }}
                    showDepositCredit={showDepositCredit}
                    getDuesInfo={this.getUserDues}
                    loading={loading}
                    formatPrice={formatPrice}
                    menuOptions={menuOptionsData}
                    Link={Link}
                    product='hotel'
                    enablePointsAndCoins={enablePointsAndCoins}
                    errorToaster={errorToaster}
                    addToCookie={setCookie}
                    topBarStaticData={topBarStaticData}
                />
                <B2cLogin
                    openModal={openModal}
                    onCloseModal={this.onCloseModal}
                    {...this.props}
                />
            </Fragment>
        );
    }
}

const mapDispatchToProps = dispatch => ({
    getUserInfoData: () => {
        dispatch(getUserInfoData());
    },
    refreshToken() {
        dispatch(refreshToken());
    },
    replaceToken(sbt) {
        dispatch(replaceToken(sbt));
    },
    navigateTo: (r) => {
        dispatch(navigateTo({ "path": r, "keys": "", "options": "" }));
    },
    getUserDues: () => {
        dispatch(getUserDues());
    },
    loginGuestUser: () => {
        dispatch(loginGuestUser());
    }
});

const mapStateToProps = state => {
    const { userinfos = {}, menubarList = {} } = state;
    const { userInfo = {}, success = false, registerSuccess = false, loading = false } = userinfos,
        { sbt = '', replacedUser = {}, getMenubar = [] } = menubarList;
    return {
        ...state, replacedUser,
        userInfo, sbt,
        loginSuccess: success,
        registerSuccess, loading,
        getMenubar
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(TopMenuList);
